'use client'

import { useEffect } from 'react'
import { useRouter } from '@/shared/config/i18n'
import { projectStorage } from '@/shared/lib/project-storage'
import { paths } from '@/shared/routing'
import { projectQueries } from '@/entities/project'

export function AuthRedirect() {
  const router = useRouter()
  const projectsQuery = projectQueries.useGet()

  useEffect(() => {
    if (projectsQuery.isLoading) {
      return
    }

    const lastProjectId = projectStorage.getLastProjectId()
    const projects = projectsQuery.data || []

    if (projects.length === 0) {
      router.replace(paths.createProject)
      return
    }

    // Если есть сохраненный проект и он существует - идем на него
    if (lastProjectId) {
      const projectExists = projects.some((p) => p.id.toString() === lastProjectId)
      if (projectExists) {
        router.replace(paths.projectWithSlug(lastProjectId))
        return
      }
    }

    // Если нет сохраненного проекта или он не найден - идем на первый проект
    const firstProject = projects[0]
    const firstProjectId = firstProject.id.toString()
    projectStorage.setLastProjectId(firstProjectId)
    router.replace(paths.projectWithSlug(firstProjectId))
  }, [projectsQuery.isLoading, projectsQuery.data, router])

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-muted-foreground">Загрузка...</div>
    </div>
  )
}
